"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var share_button_html_1 = __importDefault(require("./share-button.html"));
(function (module) {
    'use strict';
    function ShareButtonController(managePublicReportModal, metricsService) {
        var $ctrl = this;
        angular.extend($ctrl, {
            shareReport: function () {
                managePublicReportModal.show(metricsService.CALL_SOURCE.BUTTON);
            }
        });
    }
    ShareButtonController.$inject = ['prManagePublicReportModal', 'prMetricsService'];
    module.component('prShareButton', {
        templateUrl: share_button_html_1.default,
        controller: ShareButtonController
    });
})(angular.module('qualtrics.pr'));
